import React from 'react';
import SingleIcon from '@utils/icons/SingleIcon';

const EmptyLinks = () => {
  return (
    <>
      <li className="py-4 my-4 overflow-hidden bg-white rounded-lg shadow-lg hover:shadow-sm  hover:cursor-pointer hover:scale-105 transition-all">
        <div className="flex">
          <div className="self-center text-4xl px-3">
            <SingleIcon
              iconComponentName="FaHandPeace"
              size={40}
              color="#2A2A2A"
            />
          </div>
          <div className="grid px-3" style={{ color: '#2A2A2A' }}>
            <h3 className="self-center text-lg font-semibold">
              Willkommen auf deiner Profilseite!
            </h3>
            <p className="self-center text-lg overflow-hidden whitespace-nowrap "></p>
          </div>
        </div>
      </li>
      <li className="py-4 my-4 overflow-hidden bg-white rounded-lg shadow-lg hover:shadow-sm  hover:cursor-pointer hover:scale-105 transition-all">
        <div className="flex">
          <div className="self-center text-4xl px-3">
            <SingleIcon iconComponentName="FaBan" size={40} color="#2A2A2A" />
          </div>
          <div className="grid px-3" style={{ color: '#2A2A2A' }}>
            <h3 className="self-center text-lg font-semibold">
              Du hast aktuell noch keine Links definiert.
            </h3>
            <p className="self-center text-lg overflow-hidden whitespace-nowrap "></p>
          </div>
        </div>
      </li>
      <li className="py-4 my-4 overflow-hidden bg-white rounded-lg shadow-lg hover:shadow-sm  hover:cursor-pointer hover:scale-105 transition-all">
        <div className="flex">
          <div className="self-center text-4xl px-3">
            <SingleIcon iconComponentName="FaPlus" size={40} color="#2A2A2A" />
          </div>
          <div className="grid px-3" style={{ color: '#2A2A2A' }}>
            <h3 className="self-center text-lg font-semibold">
              In deinem Dashboard unter "Links" kannst du neue Links hinzufügen.
            </h3>
            <p className="self-center text-lg overflow-hidden whitespace-nowrap "></p>
          </div>
        </div>
      </li>
      <li className="py-4 my-4 overflow-hidden bg-white rounded-lg shadow-lg hover:shadow-sm  hover:cursor-pointer hover:scale-105 transition-all">
        <a className="h-full w-full" href="/dashboard/links">
          <div className="flex">
            <div className="self-center text-4xl px-3">
              <SingleIcon
                iconComponentName="FaArrowPointer"
                size={40}
                color="#2A2A2A"
              />
            </div>
            <div className="grid px-3" style={{ color: '#2A2A2A' }}>
              <h3 className="self-center text-lg font-semibold">
                Klicke hier und probiere es gleich aus!
              </h3>
              <p className="self-center text-lg overflow-hidden whitespace-nowrap "></p>
            </div>
          </div>
        </a>
      </li>
    </>
  );
};

export default EmptyLinks;
